/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MapInteger } from './MapInteger';
import {
    MapIntegerFromJSON,
    MapIntegerFromJSONTyped,
    MapIntegerToJSON,
    MapIntegerToJSONTyped,
} from './MapInteger';

/**
 * 
 * @export
 * @interface Selection
 */
export interface Selection {
    /**
     * 
     * @type {number}
     * @memberof Selection
     */
    boxId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Selection
     */
    wholeBox?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof Selection
     */
    boxGoodsIds?: Array<number>;
    /**
     * 
     * @type {MapInteger}
     * @memberof Selection
     */
    boxGoodsQuantities?: MapInteger;
}

/**
 * Check if a given object implements the Selection interface.
 */
export function instanceOfSelection(value: object): value is Selection {
    return true;
}

export function SelectionFromJSON(json: any): Selection {
    return SelectionFromJSONTyped(json, false);
}

export function SelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Selection {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'wholeBox': json['wholeBox'] == null ? undefined : json['wholeBox'],
        'boxGoodsIds': json['boxGoodsIds'] == null ? undefined : json['boxGoodsIds'],
        'boxGoodsQuantities': json['boxGoodsQuantities'] == null ? undefined : MapIntegerFromJSON(json['boxGoodsQuantities']),
    };
}

export function SelectionToJSON(json: any): Selection {
    return SelectionToJSONTyped(json, false);
}

export function SelectionToJSONTyped(value?: Selection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'wholeBox': value['wholeBox'],
        'boxGoodsIds': value['boxGoodsIds'],
        'boxGoodsQuantities': MapIntegerToJSON(value['boxGoodsQuantities']),
    };
}

